import { render } from "./Siang.vue?vue&type=template&id=bbff516e"
import script from "./Siang.vue?vue&type=script&lang=js"
export * from "./Siang.vue?vue&type=script&lang=js"
script.render = render

export default script